import React from 'react';
import { useHistory } from 'react-router-dom';
import { NavBarContainer, NavBarLogo, NavBarItem } from './styled';
import logo from "../../images/logo.png";

function NavBar() {

    const history = useHistory();

    const changePath = (path) =>{
        history.push(path);
    };

    return (
        <NavBarContainer>
            <NavBarLogo  onClick={() => changePath("/")}>
                <img src={logo} alt="" />
            </NavBarLogo>
            <NavBarItem onClick={() => changePath("/company")}>
                회사소개
            </NavBarItem>
            <NavBarItem onClick={() => changePath("/business")}>
                사업분야
            </NavBarItem>
            <NavBarItem onClick={() => changePath("/performance")}>
                사업실적
            </NavBarItem>
            <NavBarItem onClick={() => changePath("/directions")}>
                찾아오시는 길
            </NavBarItem>
        </NavBarContainer>
    );
}

export default NavBar;